import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import $ from 'jquery';
import { SubSink } from 'subsink';
import { SharedModule } from '@Shared/shared.module';
import { AppService } from 'app/app.service';
import { MultiSelectDropdownListComponent } from 'app/components/multi-select-dropdown-list/multi-select-dropdown-list.component';
import { TableColumnDefinition } from 'app/shared/components/mrs-table/models/table-models';

@Component({
  selector: 'manage-team-members-table',
  templateUrl: './team-members-table.component.html',
  styleUrls: ['../teams/app-teams.component.scss'],
  imports: [SharedModule, MultiSelectDropdownListComponent]
})
export class TeamMembersTableComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  private subs = new SubSink();
  canRead = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() data: any;
  @Input() displayedColumns: TableColumnDefinition[];
  @Input() initialSort: string;
  @Output() tableEvent = new EventEmitter<any>();

  mrsDataSource = new MatTableDataSource<any>();
  displayedColumnsDef: string[];

  constructor(
    private readonly appService: AppService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data?.currentValue !== changes.data?.previousValue && changes.data?.currentValue !== null) {
      this.setData();
    }
  }

  ngOnInit() {
    $('#sidenav').removeClass('hidenav');
    this.canRead = this.appService.checkACL('User Management', 'R');
  }

  ngAfterViewInit() {
    this.mrsDataSource.sort = this.sort;
    this.mrsDataSource.paginator = this.paginator;
  }

  setData() {
    this.mrsDataSource.sortingDataAccessor = (item, property) => {
      const def = this.displayedColumns?.find(x => x.def === property);

      if (def?.sortFields?.length) {
        let val = '';
        def.sortFields.forEach(element => {
          val += item[element];
        });
        return val.toLowerCase();
      } else {
        const value = item[property];
        if (typeof value === 'string') {
          return value.toLowerCase();
        }
        return value;
      }
    };

    const actionColumn = this.displayedColumns.find(x => x.isAction);
    this.data.forEach(element => {
      actionColumn.actions.forEach(action => {
        element[action.actionType] = true;
      });
    });

    this.mrsDataSource.paginator = this.paginator;
    this.mrsDataSource.sort = this.sort;
    this.mrsDataSource.data = this.data;

    this.displayedColumnsDef = this.displayedColumns.map(x => x.def);
  }

  tableAction(columnAction, selectedRecord) {
    this.tableEvent.emit({
      action: columnAction,
      record: selectedRecord
    });
  }

  onRowClicked(row) {
    this.tableEvent.emit({
      action: 'View',
      record: row
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
